import { TAB_HEIGHT } from './constants';
import { ITabsData } from './types';

let currentSectionIndex = 0;

const isBelowLastTabSection = (scrollHeight, lastSectionOffsetTopWithHeight) =>
  scrollHeight > lastSectionOffsetTopWithHeight;

const getLastSectionOffsetTopWithHeight = (tabs) => {
  const lastSectionHeight = tabs[tabs.length - 1]?.clientHeight;
  const lastSectionOffsetTop = tabs[tabs.length - 1]?.offsetTop;

  return lastSectionHeight + lastSectionOffsetTop;
};

export const SetActiveTab = (tabsData: ITabsData) => {
  const set = () => {
    let tabs: any[] = [];
    if (tabsData.tabSectionsRef) {
      tabs = [...tabsData.tabSectionsRef.$el.childNodes].filter((tab) => tab.nodeName != '#comment');
    }
    const scrollHeight = Math.round(window.scrollY);
    let currentTabOffsetTop = 0;
    let currentSection;

    tabs.forEach((tab, index) => {
      if (!tab) return;

      const tabOffsetTop = Math.round(tab.getBoundingClientRect().top) + scrollHeight - TAB_HEIGHT - 2;

      if (scrollHeight > tabOffsetTop && tabOffsetTop > currentTabOffsetTop) {
        const sectionID = tab.getAttribute('id');
        currentTabOffsetTop = tabOffsetTop;
        currentSectionIndex = index;
        currentSection = sectionID;
      }
    });

    const lastSectionOffsetTopWithHeight = getLastSectionOffsetTopWithHeight(tabs);
    const isBelowLastSection = isBelowLastTabSection(scrollHeight, lastSectionOffsetTopWithHeight);
    const getCurrentActiveTab = () => (currentSectionIndex == 0 ? tabsData.tabsTitles[0] : currentSection);
    return getCurrentActiveTab();
  };

  return {
    set,
  };
};
